import { render, staticRenderFns } from "./Competitions.view.vue?vue&type=template&id=801fd3dc&scoped=true&"
import script from "./Competitions.view.vue?vue&type=script&lang=js&"
export * from "./Competitions.view.vue?vue&type=script&lang=js&"
import style0 from "./Competitions.view.vue?vue&type=style&index=0&id=801fd3dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801fd3dc",
  null
  
)

export default component.exports